import { useEffect, useState } from 'react';
import { match } from 'ts-pattern';
import { UploadTypeModal } from '../../ChartExerciseMedia/UploadTypeModal';
import { useDraftChartForEdit } from '../useDraftChartForEdit';
import { DraftEachExerciseMedia } from './DraftEachExerciseMedia';
import { DraftTotalExerciseMedia } from './DraftTotalExerciseMedia';

type UploadType = '통합' | '운동별';
export const DraftChartExerciseMedia = () => {
  const [uploadType, setUploadType] = useState<UploadType | ''>('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);

  const { draftChart } = useDraftChartForEdit();

  useEffect(() => {
    if (!draftChart) return;

    if (draftChart.recordImages && draftChart.recordImages.length > 0) {
      setUploadType('통합');
    }

    if (
      (draftChart.records[0].images &&
        draftChart.records[0].images?.length > 0) ||
      (draftChart.records[0].videos && draftChart.records[0].videos?.length > 0)
    ) {
      setUploadType('운동별');
    }
  }, [draftChart]);

  return (
    <div className="flex flex-col mt-20 gap-8">
      <div className="text-[#d7d2de] text-lg font-medium font-['Pretendard Variable']">
        운동 사진 및 영상
      </div>
      {match(uploadType)
        .with('통합', () => <DraftTotalExerciseMedia />)
        .with('운동별', () => <DraftEachExerciseMedia />)
        .otherwise(() => (
          <div
            onClick={openModal}
            className="mt-20 w-full h-[54px] px-10 bg-[#2e2a3a] rounded-lg justify-center items-center gap-4 inline-flex"
          >
            <div className="text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
              업로드
            </div>
          </div>
        ))}

      {isModalOpen && (
        <UploadTypeModal
          setUploadType={setUploadType}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
